import React from 'react'
import ReactDOM from 'react-dom/client'
import { Auth0Provider } from '@auth0/auth0-react'
import App from './App'  // Changed back from DebugApp to App
import './index.css'
import { auth0Config } from './config/auth0-config'

console.log('main.tsx is executing');
console.log('Auth0 config:', {
  domain: auth0Config.domain,
  clientId: auth0Config.clientId,
  redirectUri: auth0Config.redirectUri,
  useRefreshTokens: auth0Config.useRefreshTokens,
  cacheLocation: auth0Config.cacheLocation
});

try {
  console.log('Attempting to create Auth0Provider...');
  
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: auth0Config.redirectUri,
        scope: auth0Config.scope,
      }}
      cacheLocation={auth0Config.cacheLocation}
      useRefreshTokens={auth0Config.useRefreshTokens}
    >
      <App />
    </Auth0Provider>,
  )
  
  console.log('Auth0Provider created successfully');
} catch (error) {
  console.error('Error creating Auth0Provider:', error);
} 